import { ajaxGet, ajaxPost, ajaxPostBytes } from './AjaxHelper.js'; // , ajaxPostBytes, ajaxDelete

export function checkAuthentication(callback) {
    ajaxGet("/api/extranetactions", (data, ok) => {
        callback(ok);
    })
}

export function getContacts(callback) {
    ajaxGet("/api/extranetactions/contacts", (data, ok) => {
        callback(ok ? data : null);
    });
}

// This function is currently not used and may be removed from the api in the future ( depends if we need this function in the future )
export function getUsers(callback) {
    ajaxGet("/api/extranetactions/users", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getListProjects(languageId, callback) {
    ajaxGet("/api/extranetactions/list/projects?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getListProjectsCompact(languageId, callback) {
    ajaxGet("/api/extranetactions/list/projects?languageId=" + languageId + "&compact=true", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getProjectCounters(jobId, callback) {
    ajaxGet("/api/extranetactions/list/projects/" + jobId + "/counters", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getProjectFiche(jobId, languageId, callback) {
    ajaxGet("/api/extranetactions/list/projects/" + jobId + "?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getProjectCandidates(jobId, languageId, callback) {
    ajaxGet("/api/extranetactions/list/projects/" + jobId + "/candidates?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getProjectCandidatesCompact(jobId, languageId, callback) {
    ajaxGet("/api/extranetactions/list/projects/" + jobId + "/candidates?languageId=" + languageId + "&compact=true", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getProjectDocuments(jobId, languageId, callback) {
    ajaxGet("/api/extranetactions/list/projects/" + jobId + "/documents?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getProjectMessages(jobId, languageId, callback) {
    ajaxGet("/api/extranetactions/list/projects/" + jobId + "/messages?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getListCandidates(languageId, showOpenOnly, callback) {
    ajaxGet("/api/extranetactions/list/candidates?languageId=" + languageId + "&showOpenOnly=" + showOpenOnly, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getListCandidatesCompact(languageId, callback) {
    ajaxGet("/api/extranetactions/list/candidates?languageId=" + languageId + "&showOpenOnly=false&compact=true", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getCandidateCounters(candidateId, callback) {
    ajaxGet("/api/extranetactions/list/candidates/" + candidateId + "/counters", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getCandidateFiche(candidateId, languageId, callback) {
    ajaxGet("/api/extranetactions/list/candidates/" + candidateId + "?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getCandidateProjects(candidateId, languageId, callback) {
    ajaxGet("/api/extranetactions/list/candidates/" + candidateId + "/projects?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getCandidateProjectsCompact(candidateId, languageId, callback) {
    ajaxGet("/api/extranetactions/list/candidates/" + candidateId + "/projects?languageId=" + languageId + "&compact=true", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getCandidateDocuments(candidateId, languageId, callback) {
    ajaxGet("/api/extranetactions/list/candidates/" + candidateId + "/documents?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getCandidateMessages(candidateId, languageId, callback) {
    ajaxGet("/api/extranetactions/list/candidates/" + candidateId + "/messages?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getCandidateCv(candidateId, jobId, languageId, callback) {
    ajaxGet("/api/extranetactions/list/candidates/" + candidateId + "/cv?jobId=" + jobId + "&languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getListDocuments(languageId, showOpenOnly, callback) {
    ajaxGet("/api/extranetactions/documents?languageId=" + languageId + "&showOpenOnly=" + showOpenOnly, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getListMessages(languageId, showOpenOnly, callback) {
    ajaxGet("/api/extranetactions/messages?languageId=" + languageId + "&showOpenOnly=" + showOpenOnly, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getMessage(historyId, messageId, callback) {
    ajaxGet("/api/extranetactions/message?historyId=" + historyId + "&messageId=" + messageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getExtranetOrganisationInfo(languageId, callback) {
    ajaxGet("/api/extranetactions/extranetorganisationinfo?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getExtranetUserInfo(languageId, callback) {
    ajaxGet("/api/extranetactions/extranetuserinfo?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function postExtranetUserInfo(data, callback) {
    ajaxPost("/api/extranetactions/extranetuserinfo", data, (newData, ok) => {
        callback(ok);
    });
}

export function postMessage(languageId, type, contactId, projectId, candidateId, body, callback) {
    var data = {
        type: type,
        contactId: contactId,
        projectId: projectId,
        candidateId: candidateId,
        body: body
    }

    ajaxPost("/api/extranetactions/message?languageId=" + languageId, data, (newData, ok) => {
        callback(ok ? newData : null);
    });
}

export function postMessageAttachment(file, seqtemp, historyId, languageId, callback) {
    // file = input[type=file]
    var formData = new FormData();
    formData.append("file", file.files[0]);

    var route = "/api/extranetactions/message/attachment?" 
        + "fileName=" + encodeURIComponent(file.files[0].name.split("\\").pop()) 
        + "&contentType=" + file.files[0].type 
        + "&seqtemp=" + seqtemp 
        + "&seqhis=" + historyId 
        + "&seqlang=" + languageId;

    ajaxPostBytes(route, formData, (newData, ok) => {
        callback(ok ? newData : null);
    });
}

export function postPassword(passwordCurrent, passwordNew, callback) {
    var data = {
        passwordCurrent: passwordCurrent,
        passwordNew: passwordNew
    }
    
    ajaxPost("/api/extranetactions/password", data, (newData, ok) => {
        callback(ok ? newData : false);
    });
}


// WEBPACK FOOTER //
// ./src/Api/ExtranetActions.js